import { FC } from 'react';
import { AccountsInfo } from '../AccountsViewDrawer/AccountsViewDrawer';
import { IAccountDrawerStep } from '../AccountsViewDrawer/interfaces';
import {
    AnnualIncome,
    InvestmentExperience,
    InvestmentObjectives,
    LiquidityNeeds,
    RiskTolerance,
    TimeHorizon,
} from '@shared/api';
import {
    annualIncomeOptions,
    getValueFromEnum,
    investmentExperienceOptions,
    investmentObjectivesOptions,
    liquidityNeedsOptions,
    riskToleranceOptions,
    timeHorizonOptions,
} from '../utils';
import { SelectOption } from '@shared/UI';

export const FinancialProfileStep: FC<IAccountDrawerStep> = ({ editedValues, setEditedValues, fromDetail }) => {
    const onChange = (key: string, value: string | boolean | number) => {
        setEditedValues({
            ...editedValues,
            verificationRequest: { ...editedValues.verificationRequest, [key]: value },
        });
    };

    const getValueFromDiaposon = (value: string, options: SelectOption[]) => {
        const numericValue = Number(value?.replace(/,/g, ''));

        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value) {
                return options[i].label;
            }
        }

        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            const [min, max] = option.value.replace(/,/g, '').split('-').map(Number);
            if ((numericValue >= min && numericValue <= max) || numericValue < min) {
                return AnnualIncome[i];
            }
        }

        return AnnualIncome[options.length - 1];
    };

    return (
        <div className='widget-trade-status-table-drawer__content'>
            <AccountsInfo
                value={getValueFromEnum(editedValues.verificationRequest.liquidityNeeds, LiquidityNeeds)}
                fieldName='Liquidity Needs'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                keyName='liquidityNeeds'
                options={liquidityNeedsOptions}
            />
            <AccountsInfo
                value={getValueFromEnum(editedValues?.verificationRequest.timeHorizon, TimeHorizon)}
                fieldName='Time Horizon'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                keyName='timeHorizon'
                options={timeHorizonOptions}
            />
            <AccountsInfo
                value={getValueFromEnum(editedValues?.verificationRequest.investmentExperience, InvestmentExperience)}
                fieldName='Investment Experience'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                keyName='investmentExperience'
                options={investmentExperienceOptions}
            />
            <AccountsInfo
                value={getValueFromEnum(editedValues?.verificationRequest.investmentObjectives, InvestmentObjectives)}
                fieldName='Investment Objectives'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                keyName='investmentObjectives'
                options={investmentObjectivesOptions}
            />
            <AccountsInfo
                value={getValueFromEnum(editedValues?.verificationRequest.riskTolerance, RiskTolerance)}
                fieldName='Risk Tolerance'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                keyName='riskTolerance'
                options={riskToleranceOptions}
            />
            <AccountsInfo
                className='noBorder'
                value={getValueFromDiaposon(editedValues?.verificationRequest.annualIncomeMin, annualIncomeOptions)}
                fieldName='Annual Income'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                keyName='annualIncomeMin'
                options={annualIncomeOptions}
            />
            <AccountsInfo
                className='noBorder'
                value={editedValues?.verificationRequest.taxBracket}
                fieldName='Tax Bracket'
                editableField={fromDetail ? undefined : 'range'}
                onChange={onChange}
                keyName='taxBracket'
            />
        </div>
    );
};
